/**
 * 统一处理微信服务号相关用户信息获取
 */
import getURLSearchParam, { replaceState } from './base/url'
import Agent from './agent'
import { onMiniProgramLogin } from './login'
import { reportWarn } from './owl'
import { lxMV } from './lx'

export type I_MP_ACCOUNT = Readonly<{
  accountId: number
  cnName: string
  name?: string
}>

export interface I_MP_OAUTH extends I_MP_ACCOUNT {
  mpUserInfo?: Partial<{
    openid: string
    unionId: string
    unionid: string
    nickName: string
    avatarUrl: string
  }> &
    I_MP_ACCOUNT
  openid: string
  unionId?: string
  mpact: I_MP_ACCOUNT
  ensureMpUserInfo: Function
}

type MP_ACCOUNTS = Record<string, I_MP_ACCOUNT>

export class MpOauth {
  public static MP_ACCOUNTS: MP_ACCOUNTS = {
    MPAPP: {
      // 小程序
      accountId: 2,
      cnName: '美团民宿',
    },
    HOST: {
      accountId: 1,
      name: 'zhenguohost',
      cnName: '美团民宿房东助手',
    },
    FWH: {
      accountId: 3,
      name: 'zhenguofuwu',
      cnName: '美团民宿',
    },
    HFL: {
      accountId: 6,
      name: 'zhenguohfl',
      cnName: '民宿好福利',
    },
    HMS: {
      accountId: 9,
      name: 'zhenguohms',
      cnName: '玩转好民宿',
    },
  }

  public static MP_ACCOUNTS_ID_MAP = (() => {
    const map: MP_ACCOUNTS = {}
    for (const i of Object.keys(MpOauth.MP_ACCOUNTS)) {
      map[MpOauth.MP_ACCOUNTS[i]!.accountId] = MpOauth.MP_ACCOUNTS[i] as I_MP_ACCOUNT
    }
    return map
  })()

  public mpact: I_MP_ACCOUNT

  public constructor(mpact?: I_MP_ACCOUNT) {
    this.mpact = this.getMpAccount(mpact)
    if (Agent.weixin) {
      console.log(this.mpact, this.openid, this.mpUserInfo)
    }
  }

  public getMpAccount(_mpact?: I_MP_ACCOUNT) {
    let mpact = _mpact || MpOauth.MP_ACCOUNTS['FWH']
    if (Agent.miniprogram) {
      mpact = MpOauth.MP_ACCOUNTS['MPAPP']
    }
    return mpact as I_MP_ACCOUNT
  }

  public get openid() {
    if (Agent.miniprogram) {
      const openid = getURLSearchParam('openId')
      window.$bus.$emit('wxoauth-ready', { openid })
      return openid
    }
    const openid = getURLSearchParam('openid')
    if (openid) {
      window.$bus.$emit('wxoauth-ready', { openid })
      return openid
    }
    const userInfo = this.mpUserInfo
    if (userInfo) {
      window.$bus.$emit('wxoauth-ready', userInfo)
      return userInfo.openid
    }
    return undefined
  }

  public get mpUserInfo(): I_MP_OAUTH['mpUserInfo'] {
    const mpact = this.mpact
    try {
      if (Agent.miniprogram) {
        // { openId: "", nickName: "", avatarUrl: "" }
        const mpUserInfo = JSON.parse(decodeURIComponent(getURLSearchParam('user_info'))) || {}
        // 美团小程序默认
        if (Agent.groupMpWebview) {
          // TODO DDL 2025-01-01 可能有风险
          try {
            const lxsdkParams: {
              w?: string
              wxi?: string
              [x: string]: string | undefined
            } = decodeURIComponent(getURLSearchParam('__lxsdk_params'))
              .split(';')
              .map((i) => i.split(':'))
              .reduce((p: Record<string, string>, c) => {
                if (c[0] && c[1]) p[c[0]] = c[1]
                return p
              }, {})
            mpUserInfo.openId = lxsdkParams.w
            mpUserInfo.unionId = lxsdkParams.wxi
          } catch (err) {
            reportWarn({
              name: '美团小程序获取_lxsdk_params',
              msg: err,
            })
          }
          mpUserInfo.avatarUrl = decodeURIComponent(getURLSearchParam('avatarUrl'))
          mpUserInfo.nickName = decodeURIComponent(getURLSearchParam('nickName'))
        }
        // 小程序 unionId 单独
        const unionId = getURLSearchParam('unionId')
        const _mpUserInfo = {
          openid: getURLSearchParam('openId') || mpUserInfo.openId,
          unionid: unionId || mpUserInfo.unionId,
          unionId,
          ...mpUserInfo,
          ...mpact,
        }
        window.$bus.$emit('wxoauth-ready', _mpUserInfo)
        return _mpUserInfo
      } else if (Agent.weixin) {
        const userInfo = getURLSearchParam('user_info')
        if (!userInfo) return mpact
        const wxUserInfo = JSON.parse(decodeURIComponent(userInfo))
        if (wxUserInfo.accountId !== mpact.accountId) {
          replaceState({
            user_info: undefined,
          })
          return mpact
        }
        wxUserInfo.nickName = wxUserInfo.nickname
        wxUserInfo.avatarUrl = wxUserInfo.headimgurl
        wxUserInfo.unionId = wxUserInfo.unionid
        wxUserInfo.openId = wxUserInfo.openid
        window.$bus.$emit('wxoauth-ready', wxUserInfo)
        return {
          ...wxUserInfo,
          ...mpact,
        }
      }
      return mpact
    } catch (err) {
      return mpact
    }
  }

  public ensureOpenid(path?: string): Promise<I_MP_OAUTH | undefined> {
    const mpact = this.mpact
    return new Promise((resolve) => {
      const openid = this.openid
      if (Agent.weixin && !openid) {
        if (Agent.miniprogram) {
          lxMV('b_airbnb_qo4pwb3n_mv')
          onMiniProgramLogin({
            path: path || window.location.href,
          })
        } else if (Agent.weixin) {
          window.location.replace(
            `https://h5-zhenguo.meituan.com/ecf/mpoauth/o/${mpact.name}?url=${encodeURIComponent(
              window.location.href,
            )}`,
          )
        }
      } else {
        resolve(undefined)
      }
    })
  }

  public jump2wxOauthPage(path?: string) {
    if (Agent.miniprogram) {
      onMiniProgramLogin({
        path: path || window.location.href,
      })
      return
    }
    window.location.replace(
      `https://h5-zhenguo.meituan.com/ecf/mpoauth/u/${this.mpact.name}?url=${encodeURIComponent(window.location.href)}`,
    )
  }

  /* 获取微信用户信息，包含头像昵称 */
  public ensureMpUserInfo(path?: string): Promise<I_MP_OAUTH['mpUserInfo'] | undefined> {
    return new Promise((resolve, reject) => {
      const userInfo = this.mpUserInfo
      if (Agent.weixin) {
        if (Agent.miniprogram && (!userInfo || !userInfo.unionid)) {
          this.jump2wxOauthPage(path)
          reject({
            status: -1,
            needOauth: true,
            message: '小程序未拿到用户信息，需要登录',
          })
        }
        // 新服务号不一定有 unionid
        if (!Agent.miniprogram && (!userInfo || !userInfo.openid)) {
          this.jump2wxOauthPage(path)
          reject({
            status: -1,
            needOauth: true,
            message: '用户微信未授权',
          })
        }
      }
      if (Agent.weixin) {
        resolve(userInfo)
      } else {
        resolve(undefined)
      }
    })
  }
}

let instance: MpOauth
export default function (mpact: I_MP_ACCOUNT | undefined): MpOauth {
  if (instance) return instance
  instance = new MpOauth(mpact)
  return instance
}
